import { render } from "./NotFound.vue?vue&type=template&id=f13f4588"
const script = {}
script.render = render

export default script